import styled from 'styled-components';

export const UnderlineText = styled.span`
  text-decoration: underline;
`;
